import Index from './Index.vue';
import InformationEventsAdd from './InformationEventsAdd.vue';
import InformationEventsEdit from './InformationEventsEdit.vue';
import InformationEventsDetail from './InformationEventsDetail.vue';
import RouterContainer from './RouterContainer.vue';

export default [
  {
    path: '/information-events',
    component: RouterContainer,
    children: [
      {
        path: '',
        name: 'InformationEventsIndex',
        component: Index
      },
      {
        path: 'add',
        name: 'InformationEventsAdd',
        component: InformationEventsAdd
      },
      {
        path: 'edit/:id',
        name: 'InformationEventsEdit',
        component: InformationEventsEdit
      },
      {
        path: 'detail/:id',
        name: 'InformationEventsDetail',
        component: InformationEventsDetail
      }
    ]
  }
];